var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "text-center",
      attrs: { itemscope: "", itemtype: "http://schema.org/Thing" },
    },
    [
      _c(
        "div",
        {
          staticClass: "carousel slide bx-narrative",
          attrs: {
            id: "carousel" + _vm._uid,
            "data-interval": "false",
            "data-bx-narrative-name": "gallery",
            "data-bx-narrative-group-by": "src",
          },
        },
        [
          _vm.showDots && _vm.showGallery()
            ? _c(
                "ol",
                { staticClass: "carousel-indicators" },
                _vm._l(_vm.singleImages, function (image, index) {
                  return _c("li", {
                    class: { active: index === 0 },
                    attrs: {
                      "data-target": "#carousel" + _vm._uid,
                      "data-slide-to": index,
                    },
                  })
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "carousel-inner text-center" },
            _vm._l(_vm.singleImages, function (image, index) {
              return _c(
                "div",
                {
                  staticClass: "carousel-item prop-1-1",
                  class: { active: index === 0 },
                },
                [
                  index === 0
                    ? _c("img", {
                        staticClass:
                          "position-absolute w-100 h-100 bx-narrative-item bx-narrative-button",
                        attrs: {
                          src: image.urlMiddle,
                          srcset:
                            image.urlPreview +
                            " 150w, " +
                            image.urlSecondPreview +
                            " 300w, " +
                            image.urlMiddle +
                            " 450w, " +
                            image.url +
                            " 660w",
                          alt: _vm.getAltText(image),
                          "data-bx-item-id": image.urlMiddle,
                          width: "660",
                          height: "660",
                        },
                      })
                    : _c("img", {
                        staticClass:
                          "position-absolute w-100 h-100 defer-load bx-narrative-item bx-narrative-button",
                        attrs: {
                          "data-src": image.urlMiddle,
                          "data-srcset":
                            image.urlPreview +
                            " 150w, " +
                            image.urlSecondPreview +
                            " 300w, " +
                            image.urlMiddle +
                            " 450w, " +
                            image.url +
                            " 660w",
                          alt: _vm.getAltText(image),
                          "data-bx-item-id": image.urlMiddle,
                          width: "660",
                          height: "660",
                        },
                      }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass:
                      "bx-narrative-item bx-narrative-button absolute inset-0 object-contain object-center w-full m-auto max-h-75 cursor-pointer",
                    attrs: {
                      "data-bx-item-id":
                        "https://www.nahrin.ch/media/catalog/product/cache/259ac1dc7414bbbc9b7f3d196edd39fc/v/i/virgin_mojito_drink_packshot_600x600.jpg",
                    },
                  }),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.showGallery()
            ? _c(
                "a",
                {
                  staticClass: "carousel-control-prev",
                  attrs: {
                    href: "#carousel" + _vm._uid,
                    role: "button",
                    "data-slide": "prev",
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "carousel-control-prev-icon bx-narrative-item bx-narrative-button",
                    attrs: {
                      "aria-hidden": "true",
                      "data-bx-item-id": "arrow|direction=left",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showGallery()
            ? _c(
                "a",
                {
                  staticClass: "carousel-control-next",
                  attrs: {
                    href: "#carousel" + _vm._uid,
                    role: "button",
                    "data-slide": "next",
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "carousel-control-next-icon bx-narrative-item bx-narrative-button",
                    attrs: {
                      "aria-hidden": "true",
                      "data-bx-item-id": "arrow|direction=right",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Next")]),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showThumbs && _vm.showGallery()
        ? _c(
            "div",
            {
              staticClass: "row align-content-center carousel-thumbnails mx-n2",
            },
            _vm._l(_vm.carouselImages, function (imagePreview, index) {
              return _c(
                "a",
                {
                  staticClass:
                    "col-2 px-2 pt-2 bx-narrative-item bx-narrative-button",
                  attrs: {
                    href: "#carousel" + _vm._uid,
                    "data-target": "#carousel" + _vm._uid,
                    "data-slide-to": index,
                    title: _vm.getImageName(imagePreview),
                    "data-bx-item-id": "thumb|selected=" + imagePreview.url,
                  },
                },
                [
                  _c("div", { staticClass: "prop-1-1" }, [
                    _c("img", {
                      staticClass:
                        "position-absolute w-100 h-100 defer-load border bg-white rounded",
                      attrs: {
                        "data-src": imagePreview.url,
                        alt: _vm.getAltText(imagePreview),
                        width: "85",
                        height: "85",
                      },
                    }),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }